
import commonApi from "@/apis/common.api";
import { $_DKD, $_WC } from "@/confs/common.const.js";

export default {
    state: {
        safetyCenterList: undefined,
        medicalFacList: undefined,
        policeList: undefined,
        envSensorList: undefined,
        airPollutionList:  undefined,
        waterReservoirList: undefined,
        shadeCanopyList: undefined,
    },
    getters: {
        getSafetyCenterList(state) {
            return state.safetyCenterList;
        },
        getMedicalFacList(state) {
            return state.medicalFacList;
        },
        getPoliceList(state) {
            return state.policeList;
        },
        getEnvSensorList(state) {
            return state.envSensorList;
        },
        getAirPollutionList(state) {
            return state.airPollutionList;
        },
        getWaterReservoirList(state) {
            return state.waterReservoirList;
        },
        getShadeCanopyList(state) {
            return state.shadeCanopyList;
        },
    },
    mutations: {
        SAFETY_CENTER_LIST(state, safetyCenterList) {
            state.safetyCenterList = safetyCenterList;
        },
        MEDICAL_FAC_LIST(state, medicalFacList) {
            state.medicalFacList = medicalFacList;
        },
        POLICE_LIST(state, policeList) {
            state.policeList = policeList;
        },
        ENV_SENSOR_LIST(state, envSensorList) {
            state.envSensorList = envSensorList;
        },
        AIR_POLLUTION_LIST(state, airPollutionList) {
            state.airPollutionList = airPollutionList;
        },
        WATER_RESERVOIR_LIST(state, waterReservoirList) {
            state.waterReservoirList = waterReservoirList;
        },
        SHADE_CANOPY_LIST(state, shadeCanopyList) {
            state.shadeCanopyList = shadeCanopyList;
        },
    },
    actions : {
        FETCH_SAFETY_CENTER_LIST({commit}) {
            return commonApi.fetchRepoDataListWithCodeName($_DKD.SAFETY_CENTER)
                .then((res)=>{
                    commit("SAFETY_CENTER_LIST", res.data.data);
                });
        },
        FETCH_MEDICAL_FAC_LIST({commit}) {
            return commonApi.fetchRepoDataListWithCodeName($_DKD.MEDICAL_FAC)
                .then((res)=>{
                    commit("MEDICAL_FAC_LIST", res.data.data);
                });
        },
        FETCH_POLICE_LIST({commit}) {
            return commonApi.fetchRepoDataListWithCodeName($_DKD.POLICE)
                .then((res)=>{
                    commit("POLICE_LIST", res.data.data);
                });
        },
        FETCH_ENV_SENSOR_LIST({commit}) {
            return commonApi.fetchMaxBasdtValDataList($_DKD.ENV_SENSOR)
                .then((res)=>{
                    commit("ENV_SENSOR_LIST", res.data.data);
                });
        },
        FETCH_AIR_POLLUTION_LIST({commit}) {
            return commonApi.fetchRepoDataListWithCodeName($_DKD.AIR_POLLUTION)
                .then((res)=>{
                    commit("AIR_POLLUTION_LIST", res.data.data);
                });
        },
        FETCH_WATER_RESERVOIR_LIST({commit}) {
            return commonApi.fetchRepoDataListWithCodeName($_DKD.WATER_RESERVOIR)
                .then((res)=>{
                    commit("WATER_RESERVOIR_LIST", res.data.data);
                });
        },
        FETCH_SHADE_CANOPY_LIST({commit}) {
            return commonApi.fetchRepoDataListWithCodeName($_DKD.SHADE_CANOPY)
                .then((res) => {
                    commit("SHADE_CANOPY_LIST", res.data.data);
                })
        },
    }
};
